import axios from "axios";
import { GetWebAccessToken } from "../../components/ReusebleComponents/ResuseableApiCalls";
import { path } from "../../routes/Paths";
import Call_Api from "../Handileapi/Call_api";
import { ImagesPath } from "../imagespath/imagespath";
const apiUrl = process.env.REACT_APP_BACKEND_URL;

export const getCardType = (number) => {
  const trimmedNumber = number.replace(/\s+/g, "");
  const length = trimmedNumber.length;
  if (
    (trimmedNumber.startsWith("34") || trimmedNumber.startsWith("37")) &&
    length === 15
  ) {
    return "AMEX";
  }
  if (trimmedNumber.startsWith("4") && length === 16) {
    return "VISA";
  }
  if (
    trimmedNumber.startsWith("51") ||
    trimmedNumber.startsWith("52") ||
    trimmedNumber.startsWith("53") ||
    trimmedNumber.startsWith("54") ||
    (trimmedNumber.startsWith("55") && length === 16)
  ) {
    return "Mastercard";
  }
  if (
    (trimmedNumber.startsWith("300") ||
      trimmedNumber.startsWith("301") ||
      trimmedNumber.startsWith("302") ||
      trimmedNumber.startsWith("303") ||
      trimmedNumber.startsWith("304") ||
      trimmedNumber.startsWith("305") ||
      trimmedNumber.startsWith("36") ||
      trimmedNumber.startsWith("38")) &&
    length === 14
  ) {
    return "Diners Club";
  }
  if (
    (trimmedNumber.startsWith("6011") ||
      (trimmedNumber.startsWith("5") && length === 15)) &&
    length === 16
  ) {
    return "Discover";
  }
  if (
    (trimmedNumber.startsWith("2131") || trimmedNumber.startsWith("1800")) &&
    length === 15
  ) {
    return "JCB";
  }
  if (trimmedNumber.startsWith("35") && (length === 16 || length === 15)) {
    return "JCB";
  }

  return "Unknown";
};
export async function creditCardBinAPI(cardNumber) {
  console.log("cardNumber to get bin bank code===>", cardNumber);
  try {
    if (cardNumber?.length > 6) {
      const shortCardNumber = cardNumber?.slice(0, 6);
      console.log("cardNumber===>", shortCardNumber);
      const response = await axios.get(
        `${apiUrl}/rapidDetails/getrapiDetails/${shortCardNumber}`
      );
      console.log("details while getting bin details===>", response?.data);
      if (response?.data?.brand) {
        return response?.data;
      }
      return "NoDataFound";
    }
  } catch (error) {
    console.log("error while getting bin details ===>", error?.response?.data);
  }
}
export async function checkCompareNames(firstName, secondName) {
  console.log("firstName, secondName===>", firstName, secondName);
  const cleanedFirstname = removeTitle(firstName);
  const cleanedSecondName = removeTitle(secondName);

  const firstNameToCompare = normalizeName(cleanedFirstname);
  const secondNameToCompare = normalizeName(cleanedSecondName);

  const reverseFirstName = firstNameToCompare.split(" ").reverse().join(" ");
  const reverseSecondName = secondNameToCompare.split(" ").reverse().join(" ");

  const sortedFirstName = firstNameToCompare.split(" ").sort().join(" ");
  const sortedSecondName = secondNameToCompare.split(" ").sort().join(" ");

  const jumbleReverseSecondName = reverseSecondName.split(" ").sort().join(" ");

  console.log(
    "sortedFirstName === sortedSecondName===>",
    sortedFirstName,
    sortedSecondName
  );
  console.log(
    "sortedFirstName === reverseSortedSecondName===>",
    sortedFirstName,
    jumbleReverseSecondName
  );
  if (sortedFirstName === sortedSecondName) {
    return true;
  }
  if (sortedFirstName === jumbleReverseSecondName) {
    return true;
  }

  const similarity = await compareNames(sortedFirstName, sortedSecondName);
  const reverseSimilarity = await compareNames(
    sortedFirstName,
    jumbleReverseSecondName
  );
  console.log("similarity===>", similarity);
  console.log("reverseSimilarity===>", reverseSimilarity);

  if (similarity >= 80 || reverseSimilarity >= 80) {
    return true;
  } else {
    return false;
  }
}
function normalizeName(name) {
  return name.toUpperCase().replace(/\s+/g, " ").trim();
}
function compareNames(accountName, panName) {
  const distance = levenshteinDistance(accountName, panName);
  const maxLength = Math.max(accountName.length, panName.length);
  const similarity = 1 - distance / maxLength;
  return similarity * 100;
}
function levenshteinDistance(a, b) {
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;

  const matrix = [];
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }

  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }

  return matrix[b.length][a.length];
}
function removeTitle(name) {
  const titleRegex = /^(MR|MRS|MISS|MS|DR|SIR|LADY|LORD|PROF|REV)\.?\s*/i;
  return name.replace(titleRegex, "").trim();
}

export const fetchWalletPayOutCharges = async (
  userDetails,
  detailsToSend,
  token
) => {
  console.log('calling fetchWalletPayOutCharges user have wallet');
  const schemeName = userDetails?.walletScheme;
  console.log("schemeName ===>>", schemeName)
  try {
    const details = {
      paymentMethod: detailsToSend?.subService,
      paymentMode: detailsToSend?.serviceName,
      paymentType: detailsToSend?.subService,
      serviceName: 'PayOut',
    };
    const response = await Call_Api(
      path.GET_PAYOUT_CHARGES_BY_WALLET_SCHEME(schemeName),
      'POST',
      details,
      token
    );
    console.log("response of wallet payout charges===>", response)
    return response?.response?.length > 0
      ? response?.response[0]
      : { payOutPercentage: 0, payOutFee: 0 };
  } catch (error) {
    console.error('Error fetching wallet payout charges:', error);
  }
};

// export async function checkCompareNames(firstName, secondName) {
//     console.log("firstName, secondName===>", firstName, secondName)
//     const firstNameToCompare = firstName?.toUpperCase()
//     const secondNameToCompare = secondName?.toUpperCase()
//     const reverseFirstName = firstNameToCompare?.split(" ").reverse().join(" ")
//     const reverseSecondName = secondNameToCompare?.split(" ").reverse().join(" ")
//     const sortedFirstName = firstNameToCompare.split(" ").map(word => word.trim()).filter(Boolean)
//     const sortedSecondName = secondNameToCompare.split(" ").map(word => word.trim()).filter(Boolean)
//     const reverserSprtedFirstName = reverseFirstName?.split(" ").map(word => word?.trim()).filter(Boolean)
//     const reverseSortedSecondName = reverseSecondName?.split(" ").map(word => word?.trim()).filter(Boolean)
//     const jumbleFirstName = sortedFirstName?.sort().join(' ')
//     const jubmleSecondName = sortedSecondName?.sort()?.join(" ")
//     const jumbleReverseSecondName = reverseSortedSecondName?.sort()?.join(" ")
//     console.log("sortedFirstName === sortedSecondname===>", jumbleFirstName, jubmleSecondName)
//     console.log("sortedFirstName === sortedSecondname===>", jumbleFirstName, jumbleReverseSecondName)
//     if (jumbleFirstName === jubmleSecondName) {
//         return true
//     }
//     if (jumbleFirstName === jumbleReverseSecondName) {
//         return true
//     }
//     else {
//         const similarity = await compareNames(jumbleFirstName, jubmleSecondName)
//         const reverseSimilarity=await compareNames(jumbleFirstName,jumbleReverseSecondName)
//         console.log("similarity===>", similarity)
//         console.log("reverseSimilarity===>", reverseSimilarity)

//         if(similarity >= 95 || reverseSimilarity >= 95){
//             return true
//         }else{
//             return false
//         }
//     }

// }

// function compareNames(accountName, panName) {
//     const distance = levenshteinDistance(accountName, panName);
//     const maxLength = Math.max(accountName.length, panName.length);
//     const similarity = 1 - distance / maxLength;
//     return similarity * 100;
// }
// function levenshteinDistance(a, b) {
//     if (a.length === 0) return b.length;
//     if (b.length === 0) return a.length;

//     const matrix = [];
//     for (let i = 0; i <= b.length; i++) {
//         matrix[i] = [i];
//     }

//     for (let j = 0; j <= a.length; j++) {
//         matrix[0][j] = j;
//     }
//     for (let i = 1; i <= b.length; i++) {
//         for (let j = 1; j <= a.length; j++) {
//             if (b.charAt(i - 1) === a.charAt(j - 1)) {
//                 matrix[i][j] = matrix[i - 1][j - 1];
//             } else {
//                 matrix[i][j] = Math.min(
//                     matrix[i - 1][j - 1] + 1,
//                     matrix[i][j - 1] + 1,
//                     matrix[i - 1][j] + 1
//                 );
//             }
//         }
//     }

//     return matrix[b.length][a.length];
// }

// export const validateDetails = (currentYear, currentMonth, enteredDetails) => {
//     console.log("validateDetails ======>>>", currentYear, currentMonth, enteredDetails)
//     const errors = [];

//     if (!enteredDetails?.holderName?.trim()) {
//       errors.push("Name on Credit Card is required.");
//       return
//     }

//      if (!enteredDetails?.monthAndYear?.trim()) {
//       errors.push("Expiry of Credit Card is required.");
//       return
//     }

//     if (!enteredDetails?.cvv?.trim()) {
//       errors.push("Cvv of Credit Card is required.");
//       return
//     }

//       const [expMonth, expYear] = enteredDetails.monthAndYear
//         .split("/")
//         .map(Number);

//       if (
//         expYear < currentYear ||
//         (expYear === currentYear && expMonth < currentMonth)
//       ) {
//         errors.push("The card expiration date must be in the future.");
//         return
//       }
//       console.log("errors", errors)
//     return errors;
//   };

export const validateDetails = (currentYear, currentMonth, enteredDetails) => {
  console.log(
    "validateDetails ======>>>",
    currentYear,
    currentMonth,
    enteredDetails
  );

  // Check for empty fields and return the first error
  if (!enteredDetails?.holderName?.trim()) {
    return ["Name on Credit Card is required."];
  }

  if (!enteredDetails?.monthAndYear?.trim()) {
    return ["Expiry of Credit Card is required."];
  }

  if (!enteredDetails?.cvv?.trim()) {
    return ["Cvv of Credit Card is required."];
  }

  if (
    !/^(0[1-9]|1[0-2])\/([0-9]{2})$/.test(enteredDetails?.monthAndYear?.trim())
  ) {
    return ["Expiry of Credit Card is in wrong format."];
  }

  // Validate expiry date
  const [expMonth, expYear] = enteredDetails.monthAndYear
    .split("/")
    .map(Number);

  if (
    expYear < currentYear ||
    (expYear === currentYear && expMonth < currentMonth)
  ) {
    return ["The card expiration date must be in the future."];
  }

  // If everything is valid, return an empty array (no errors)
  return [];
};

export const getImage = (image) => {
  const lowerImage = image?.toLowerCase();
  switch (lowerImage) {
    case "reliance jio infocomm limited":
      return ImagesPath.jio;
    case "airtel":
      return ImagesPath.airtel;
    case "bsnl":
      return ImagesPath.bsnl;
    case "vodafone":
      return ImagesPath.vodafoneidea;
    case "idea":
      return ImagesPath.vodafoneidea;
    default:
      return "";
  }
};

export const getPayOutCharges = async (
  userDetails,
  detailsForGeneralSchemes,
  token
) => {
  const schemeName = userDetails?.schemeName;
  console.log(
    "payout chargres from genral schemes====>",
    detailsForGeneralSchemes
  );
  try {
    const response = await Call_Api(
      path.GET_SCHEMEDETAILS_SCHEME_NAME(schemeName),
      "POST",
      detailsForGeneralSchemes,
      token
    );
    console.log("response in charges", response);
    let newData;
    if (response?.success) {
      newData = response?.response?.data;
    } else {
      newData = [];
    }
    console.log(
      "calling payout chargres from genral schemes user doen't have wallet",
      newData
    );
    const paymentDetails = newData[0]?.paymentConfigurations;
    if (paymentDetails && paymentDetails.length > 0) {
      return {
        ...paymentDetails[0],
        paymentGateway: newData[0]?.paymentGateway,
      };
    }
  } catch (error) {
    console.log(
      "Error while fetching the payout charges from general schemes===>",
      error
    );
  }
};

export const generateTransactionId = () => {
  const now = new Date();
  const date = now.toISOString().slice(0, 10).replace(/-/g, "");
  const time = now.toISOString().slice(11, 19).replace(/:/g, "");
  const random = Math.random().toString(36).substr(2, 4).toUpperCase();
  return `BIZZ_${date}${time}${random}`;
};

export const isCreditCardInput = (item, detailsToSend) => {
  return (
    detailsToSend?.serviceName?.toUpperCase() ===
      "CREDIT CARD" && Number(item?.maxLength) === 4
  );
};

export const isInputValid = (
  value,
  min,
  max,
  regex,
  item,
  serviceName,
  record,
  creditCardNumber
) => {
  const isCreditCard =
    (serviceName?.toUpperCase() || record?.toUpperCase()) === "CREDIT CARD" &&
    Number(item?.maxLength) === 4;

  // 👉 Credit card validation uses creditCardNumber (16 digits)
  if (isCreditCard) {
    if (!creditCardNumber) return "Mandatory";
    if (creditCardNumber.length === 16) return "valid";
    return "Mandatory";
  }

  // 👉 Normal field validation
  const pattern = new RegExp(regex);
  if (!pattern.test(value)) return "InValid";
  if (value.length < min || value.length > max) return "Mandatory";
  return "valid";
};


export const getPaymentStatus = (transaction) => {
  const status = transaction?.payOutStatus?.toUpperCase();
  if (status === "SUCCESS" || status === "PROCESSED") {
    return "SUCCESS";
  } else if (status === "FAILED") {
    return "FAILED";
  } else if (status === "REVERSED") {
    return "REVERSED";
  } else if (status === "PROCESSING") {
    return "PROCESSING";
  } else if (
    !status &&
    transaction?.payInStatus?.toUpperCase() === "PROCESSING"
  ) {
    return "PROCESSING";
  } else {
    return "FAILED";
  }
};

export const getPaymentMadeFor = (paymentData) => {
  if (!paymentData) return "Transaction details are unavailable.";
  const {
    actualAmount,
    operator,
    subService,
    transactionDate,
    transactionTime,
    transactionType,
    beneficiaryName,
    serviceName,
    payOutStatus,
    payInStatus,
  } = paymentData;
  const status = payOutStatus?.toLowerCase() || payInStatus?.toLowerCase();
  const timeStr = `on ${transactionDate} at ${transactionTime}.`;
  if (
    [
      "Rental",
      "Vendors",
      "referral_Settlements",
      "PayOut_Settlements",
    ].includes(serviceName) ||
    ["Transfer", "Educational"].includes(subService)
  ) {
    return `${transactionType} of ₹${actualAmount} was made to ${beneficiaryName} and was ${status}. ${timeStr}`;
  }
  if (
    serviceName?.toUpperCase() == "SETTLEMENTS" &&
    subService?.toUpperCase != "TRANSFER"
  ) {
    return `${transactionType} of ₹${actualAmount} was ${status} to the Wallet ${timeStr}`;
  }
  return `An amount of ₹${actualAmount} was debited for ${operator} (${subService}) and was ${status} ${timeStr}`;
};

export function getQuestions(subService, paymentType, serviceName) {
  console.log("subService ===>>", subService, paymentType, serviceName);
  const lowerSubService = subService?.toLowerCase();
  const higherPaymentType = paymentType?.toUpperCase();
  const higherserviceName = serviceName?.toUpperCase();
  let questions = [];

  if (lowerSubService === "bill payments") {
    if (higherPaymentType == "SUCCESS") {
      questions.push({
        question: "Double Dedit",
        code: "DD",
        type: "user",
        transactionType: "Wallet Payout",
        isVisible: true,
        subQuestions: [],
      });
    }

    if (higherPaymentType == "PROCESSING") {
      questions.push({
        question: "Money Dedited But Not Credited",
        code: "MDBNC",
        type: "user",
        transactionType: "Wallet Payout",
        isVisible: true,
        subQuestions: [],
      });
    }
  } else if (lowerSubService === "payout_settlements") {
    questions.push(
      {
        question: "Double Dedit",
        code: "DD",
        type: "user",
        transactionType: "Wallet Payout",
        isVisible: true,
        subQuestions: [],
      },
      {
        question: "Money Dedited But Not Credited",
        code: "MDBNC",
        type: "user",
        transactionType: "Wallet Payout",
        isVisible: true,
        subQuestions: [],
      }
    );
  } else if (lowerSubService === "referral_settlements") {
    questions.push(
      {
        question: "Failed But Debited",
        code: "FBD",
        type: "user",
        transactionType: "Wallet Related",
        isVisible: false,
        subQuestions: [
          {
            question: "Check Transaction Status",
            code: "CTS",
            type: "user",
            transactionType: "Wallet Related",
            isVisible: false,
            subQuestions: [
              {
                question: "Credit to Wallet",
                code: "CTW",
                type: "user",
                transactionType: "Wallet Related",
                isVisible: false,
              },
              {
                question: "Credit to Card",
                code: "CTC",
                type: "user",
                transactionType: "Wallet Related",
                isVisible: false,
              },
            ],
          },
        ],
      },
      {
        question: "Payment Success But not Credited",
        code: "PSBNC",
        type: "user",
        transactionType: "Wallet Related",
        subQuestions: [],
        isVisible: false,
      },
      {
        question: "Payment Processing",
        code: "PP",
        type: "user",
        transactionType: "Wallet Related",
        subQuestions: [],
        isVisible: false,
      }
    );
  } else if (
    ["CREDIT CARD", "ELECTRICITY", "WATER", "DTH"].includes(higherserviceName)
  ) {
    questions.push(
      {
        question: "Failed But Debited",
        code: "FBD",
        type: "user",
        transactionType: "Wallet Related",
        isVisible: false,
        subQuestions: [],
      },
      {
        question: "Payment Success But not Credited",
        code: "PSBNC",
        type: "user",
        transactionType: "Wallet Related",
        subQuestions: [],
        isVisible: false,
      },
      {
        question: "Payment Processing",
        code: "PP",
        type: "user",
        transactionType: "Wallet Related",
        subQuestions: [],
        isVisible: false,
      }
    );
  } else if (
    higherserviceName == "SETTLEMENTS" &&
    lowerSubService !== "transfer"
  ) {
    if (higherPaymentType === "FAILED") {
      questions.push({
        question: "Failed But Debited",
        code: "FBD",
        type: "user",
        transactionType: "Wallet Related",
        isVisible: true,
        subQuestions: [
          {
            question: "Check Transaction Status",
            code: "CTS",
            type: "user",
            transactionType: "Wallet Related",
            isVisible: false,
          },
        ],
      });
    } else if (higherPaymentType === "SUCCESS") {
      questions.push({
        question: "Payment Success But not Credited",
        code: "PSBNC",
        type: "user",
        transactionType: "Wallet Related",
        subQuestions: [
          {
            question: "Check Transaction Status",
            code: "CTS_PSBNC",
            type: "user",
            transactionType: "Wallet Related",
            isVisible: false,
          },
        ],
      });
    } else {
      questions.push({
        question: "Payment Processing",
        code: "PP",
        type: "user",
        transactionType: "Wallet Related",
        subQuestions: [
          {
            question: "Check Transaction Status",
            code: "CTS_PP",
            type: "user",
            transactionType: "Wallet Related",
            isVisible: false,
          },
        ],
      });
    }
  }

  return questions;
}

export const getTransactionDate = (time) => {
  const today = new Date();
  switch (time) {
    case "T":
      return today.toDateString();
    case "T+1":
      today.setDate(today.getDate() + 1);
      return today.toDateString();
    case "T+2":
      today.setDate(today.getDate() + 2);
      return today.toDateString();
    default:
      return "";
  }
};

export const fetchTransactionStatus = async (transaction) => {
  console.log({ transaction });
  const token = await GetWebAccessToken();
  let body = {};
  const headers = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Authorization: `Bearer ${token}`,
  };
  const pg = transaction?.paymentGateWay?.toUpperCase();
  if (
    pg === "CASHFREE_FASTAG" ||
    pg === "CASHFREE_BBPS" ||
    pg === "CASHFREEWEBVIEW" ||
    pg === "CASHFREE_SEAMLESS" ||
    pg === "CASHFREE_OPTIMISER"
  ) {
    body = {
      transactionId: transaction.transactionId,
      paymentGateWay: transaction.paymentGateWay,
      referenceId: transaction.referenceId,
      serviceName: transaction.serviceName,
    };
  } else {
    body = {
      transactionId: transaction.transactionId,
      paymentGateWay: transaction.paymentGateWay,
      serviceName: transaction.serviceName,
      referenceId: transaction.referenceId,
    };
  }
  try {
    const response = await axios.post(
      `${apiUrl}/KycHelp/chatbot/transactionRelatedQuery`,
      body,
      {
        headers,
      }
    );
    console.log(response, "response in cts");
    if (response.data && response.data.status) {
      return response.data || {};
    } else {
      console.error("Unexpected response format:", response.data);
      return {
        message: "Failed to fetch transaction status. Please try again later.",
        statusText: "ERROR",
        status: "",
      };
    }
  } catch (error) {
    console.error("Error fetching transaction status:", error);
    return {
      message: "Something went wrong while fetching the transaction status.",
      statusText: "ERROR",
      status: "",
    };
  }
};

export const getTransactionDateTime = (paymentData) => {
  const { transactionDate, transactionTime } = paymentData || {};
  if (!transactionDate || !transactionTime) return null;

  const [day, month, year] = transactionDate.split("/");
  const [time, ampm] = transactionTime.split(" ");
  let [hours, minutes, seconds] = time.split(":");
  hours = parseInt(hours, 10);
  if (ampm?.toUpperCase() === "PM" && hours < 12) hours += 12;
  if (ampm?.toUpperCase() === "AM" && hours === 12) hours = 0;

  const dateObj = new Date(
    `${year}-${month}-${day}T${pad(hours)}:${pad(minutes)}:${pad(
      seconds || "00"
    )}`
  );
  return isNaN(dateObj) ? null : dateObj;
};

const pad = (num) => num.toString().padStart(2, "0");

export const getHoursSince = (pastDate) => {
  if (!pastDate) return Infinity;
  const now = new Date();
  const diffMs = now - pastDate;
  return diffMs / (1000 * 60 * 60);
};

export const saveUserAndBotMessages = async (
  userQues,
  botReply,
  paymentData
) => {
  const token = await GetWebAccessToken();
  const messageDetails = {
    user: userQues,
    bot: botReply,
  };
  const queryResponse = await Call_Api(
    path?.SAVE_MESSAGES_OF_TRANSACTION(
      paymentData?.MerchantId,
      paymentData?.mobileNumber,
      paymentData?.transactionId
    ),
    "POST",
    messageDetails,
    token
  );
};
